import { fetchCacheItems } from '../../../../actions/fetchCacheItems';
import { fetchFinItems } from '../../../../actions/fetchFinItems';
import { fetchItems } from '../../../../actions/fetchItems';
import { fetchReadItems } from '../../../../actions/fetchReadItems';
import {
  FetchCacheItemsSources,
  FetchCacheItemsTrackTotalHits,
  FetchCacheItemsTrackWithMetadata,
  FetchItemsFilters,
  FetchItemsGqlQuery,
  FetchItemsLimit,
  FetchItemsPage,
  FetchItemsSort
} from '../../../../../../../types';

interface FetchCacheItemsOptions {
  filters: FetchItemsFilters;
  limit: FetchItemsLimit;
  page: FetchItemsPage;
  query: FetchItemsGqlQuery;
  sort: FetchItemsSort;
  source?: FetchCacheItemsSources;
  targetApi?: 'api' | 'read_api' | 'fin_api' | 'cache_api';
  trackTotalHits?: FetchCacheItemsTrackTotalHits;
  withMetadata?: FetchCacheItemsTrackWithMetadata;
}

function handleFetchCacheItems({
  filters,
  limit,
  page,
  query,
  sort,
  source = FetchCacheItemsSources.ES,
  trackTotalHits = false,
  withMetadata = false,
  targetApi = 'api',
  ...additionalParams
}: FetchCacheItemsOptions) {
  switch (targetApi) {
    case 'api':
      return fetchItems({
        query,
        filters,
        sort,
        page,
        limit,
        ...additionalParams
      });
    case 'cache_api':
      return fetchCacheItems({
        query,
        source,
        trackTotalHits,
        withMetadata,
        filters,
        sort,
        page,
        limit,
        ...additionalParams
      });
    case 'read_api':
      return fetchReadItems({
        query,
        filters,
        sort,
        page,
        limit,
        ...additionalParams
      });
    case 'fin_api':
      return fetchFinItems({
        query,
        filters,
        sort,
        page,
        limit,
        ...additionalParams
      });
  }
}

export default handleFetchCacheItems;
